angular.module('b2bRegistrationFlowBundle').directive('sdNgIndeterminate', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            scope.$watch(attributes['sdNgIndeterminate'], function (value) {
                element.prop('indeterminate', !!value);
            });
        }
    };
});
